import template from './print.html';
import controller from './print.controller';
import './print.scss';

let printComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default printComponent;


// WEBPACK FOOTER //
// ./client/app/components/routeSheet/print/print.component.js